import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="pt-4 pb-12 px-6 flex flex-col items-center text-center relative z-10" data-id="element-38">
        <div className="w-16 h-[1px] bg-copper opacity-50 mb-8" data-id="element-39" />

        <p className="font-playfair italic text-charcoal text-lg opacity-70 max-w-xs leading-relaxed mb-8" data-id="element-40">
          "Made for the mothers who are allowed to breathe now."
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-41">
          <div className="flex items-center gap-4 font-inter text-charcoal text-xs opacity-60" data-id="element-42">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-copper hover:opacity-100 transition-colors underline underline-offset-4" data-id="element-43">
              Privacy Policy
            </button>
            <span data-id="element-44">·</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-copper hover:opacity-100 transition-colors underline underline-offset-4" data-id="element-45">
              Terms of Service
            </button>
          </div>
          <p className="font-inter text-charcoal text-xs opacity-40" data-id="element-46">
            © 2026 Gemma Mama
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-47">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-48">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-charcoal/20 backdrop-blur-sm" data-id="element-49" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-lg max-h-[80vh] bg-[#F8F5F0] rounded-2xl shadow-[0_20px_60px_-15px_rgba(122,74,32,0.3)] border border-copper/20 overflow-hidden flex flex-col" data-id="element-50">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-copper/10 bg-white/50" data-id="element-51">
                <h3 className="font-playfair text-2xl text-charcoal font-medium" data-id="element-52">
                  {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-copper/10 text-copper transition-colors" data-id="element-53">
                  <X className="w-5 h-5" data-id="element-54" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-charcoal/80 leading-relaxed space-y-4" data-id="element-55">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-56">
                      <strong data-id="element-57">1. Information We Collect</strong>
                      <br data-id="element-58" />
                      We collect information you provide directly to us when you
                      make a purchase, including your name, email address, and
                      payment information.
                    </p>
                    <p data-id="element-59">
                      <strong data-id="element-60">2. How We Use Your Information</strong>
                      <br data-id="element-61" />
                      We use the information we collect to process your
                      transactions, send you the digital products you purchased,
                      and communicate with you about your order.
                    </p>
                    <p data-id="element-62">
                      <strong data-id="element-63">3. Data Security</strong>
                      <br data-id="element-64" />
                      We implement appropriate security measures to protect your
                      personal information against unauthorized access or
                      disclosure.
                    </p>
                  </> : <>
                    <p data-id="element-65">
                      <strong data-id="element-66">1. Digital Products</strong>
                      <br data-id="element-67" />
                      The Audio Sanctuary is a digital product. Upon purchase,
                      you will receive instant access to the audio files. Due to
                      the digital nature of this product, all sales are final.
                    </p>
                    <p data-id="element-68">
                      <strong data-id="element-69">2. Personal Use Only</strong>
                      <br data-id="element-70" />
                      The audio guides provided are for your personal,
                      non-commercial use only. You may not distribute, modify,
                      transmit, reuse, download, repost, copy, or use said
                      content for commercial purposes.
                    </p>
                    <p data-id="element-71">
                      <strong data-id="element-72">3. Medical Disclaimer</strong>
                      <br data-id="element-73" />
                      These audio guides are designed for nervous system
                      regulation and relaxation. They are not a substitute for
                      professional medical advice, diagnosis, or treatment.
                    </p>
                    <p data-id="element-74">
                      <strong data-id="element-75">4. Modifications</strong>
                      <br data-id="element-76" />
                      We reserve the right to modify these terms at any time.
                      Your continued use of the product constitutes agreement to
                      such modifications.
                    </p>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}